import * as t from 'io-ts';

import {ActivityVisualTypesEnum, RActivityIdRef} from '../../../../models/api/activityModel';

/*
 * Runtime type.
 */

const RMessageActivityViewerState = t.type({
  type: t.literal(ActivityVisualTypesEnum.MESSAGE),
  activityId: RActivityIdRef,
  isExpanded: t.boolean,
  hasFailedToLoad: t.boolean,
  isExternalContentHidden: t.boolean,
});

const RCommentActivityViewerState = t.type({
  type: t.literal(ActivityVisualTypesEnum.COMMENT),
  activityId: RActivityIdRef,
});

const RBasicActivityViewerState = t.type({
  type: t.literal(ActivityVisualTypesEnum.BASIC),
  activityId: RActivityIdRef,
  isExpanded: t.boolean,
});

export const RActivityViewerState = t.taggedUnion(
  'type',
  [RMessageActivityViewerState, RCommentActivityViewerState, RBasicActivityViewerState],
  'activityViewerState',
);

/*
 * Types.
 */

export interface MessageActivityViewerState extends Readonly<t.TypeOf<typeof RMessageActivityViewerState>> {}
export interface CommentActivityViewerState extends Readonly<t.TypeOf<typeof RCommentActivityViewerState>> {}
export interface BasicActivityViewerState extends Readonly<t.TypeOf<typeof RBasicActivityViewerState>> {}

export type ActivityViewerState =
  | MessageActivityViewerState
  | CommentActivityViewerState
  | BasicActivityViewerState;
